// React i hooks
import { memo, useCallback, useEffect, useState } from "react";

// Tipovi i konstante
import { PublicApiDetailCardProps } from "./types";
import { PublicApiSettings } from "services/api/settings/publicApi/types";

// UI komponente
import { Loader } from "ui/components/Loader";
import PublicApiStatusCard from "./components/PublicApiStatusCard/PublicApiStatusCard";
import PublicApiKeysCard from "./components/PublicApiKeysCard/PublicApiKeysCard";

// API
import {
  getPublicApiSettingsAPI,
  updatePublicApiSettingsAPI,
} from "services/api/settings/publicApi/api";

/**
 * Drži postavke javnog API-ja i dijeli ih karticama ispod. Jedan dohvat za obje: popis
 * ključeva i prekidač dolaze iz istog odgovora.
 */
const PublicApiDetailCard: React.FC<PublicApiDetailCardProps> = () => {
  const [settings, setSettings] = useState<PublicApiSettings | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const fetchSettings = useCallback(async () => {
    try {
      setSettings(await getPublicApiSettingsAPI());
    } catch {
      // greške rukuje createApiCall (snackbar)
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const handleEnabledChange = useCallback(async (enabled: boolean) => {
    setIsSaving(true);

    try {
      setSettings(await updatePublicApiSettingsAPI(enabled));
    } catch {
      // prekidač ostaje na staroj vrijednosti — stanje dolazi iz poslužitelja
    } finally {
      setIsSaving(false);
    }
  }, []);

  if (!settings) {
    return <Loader isLoading={isLoading} />;
  }

  return (
    <div className="">
      <PublicApiStatusCard
        settings={settings}
        isSaving={isSaving}
        onEnabledChange={handleEnabledChange}
      />
      <PublicApiKeysCard settings={settings} onChanged={fetchSettings} />
    </div>
  );
};

export default memo(PublicApiDetailCard);
